module.exports = __webpack_public_path__ + "static/img/zgtp.ce16f02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/zgtp.png
// module id = Sqj5
// module chunks = 44